const state = {
  token: '',
  downloadUrl: 'https://apps.apple.com/app/id6495976783',
}

const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
